export default __webpack_public_path__ + "static/media/abudhabi.55492ae8.svg";